import withStyles from 'isomorphic-style-loader/withStyles';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { debounce } from 'debounce';
import { END_TRANSPORT_HOVERING, START_TRANSPORT_HOVERING } from '../actions/TransportOverlay';
import { WINDOW_SIZE_ENUM } from '../types/IWindowSize';
import ContextMenuButton from './ContextMenuButton';
import FullScreenButton from './FullScreenButton';
import VideoUITimeoutMS from '../utils/VideoUITimeoutMS';
import * as Styles from './VideoContainerTopSection.scss';
class VideoContainerTopSection extends Component {
    constructor(props) {
        super(props);
        this.handleMouseOver = () => {
            const timestamp = Date.now();
            this.setState({ transportHoverTimestamp: timestamp });
            this.props.dispatch({ type: START_TRANSPORT_HOVERING, payload: { timestamp } });
            this.debouncedEndHover();
        };
        this.handleMouseLeave = () => {
            this.props.dispatch({ type: END_TRANSPORT_HOVERING });
        };
        this.state = {
            transportHoverTimestamp: 0,
        };
        this.debouncedEndHover = debounce(() => {
            this.props.dispatch({ type: END_TRANSPORT_HOVERING });
        }, VideoUITimeoutMS.Hover4s);
    }
    async componentDidUpdate() {
        const { lastHoverTimestamp } = this.props;
        if (this.state.transportHoverTimestamp &&
            lastHoverTimestamp !== this.state.transportHoverTimestamp) {
            this.debouncedEndHover.clear();
            this.setState({ transportHoverTimestamp: undefined });
        }
    }
    render() {
        const { isTransportHovering, isTransportOverlayOpen, media, showControls, windowWidth, } = this.props;
        const buttonSize = windowWidth < WINDOW_SIZE_ENUM.SM ? 'small' : 'medium';
        const showContainerSection = (showControls || isTransportHovering) && !isTransportOverlayOpen;
        const containerSectionClassName = showContainerSection ? '' : Styles.hidden;
        return (React.createElement("div", { id: "videoContainerTopSection", className: containerSectionClassName, onMouseOver: this.handleMouseOver, onMouseLeave: this.handleMouseLeave },
            React.createElement(FullScreenButton, { size: buttonSize }),
            (media === null || media === void 0 ? void 0 : media.contextMenu) && Object.keys(media.contextMenu).length !== 0 && (React.createElement("div", { className: Styles.contextMenuContainer },
                React.createElement(ContextMenuButton, { options: media.contextMenu.options, disabled: media.contextMenu.disabled, variant: "primary", iconName: "more", size: buttonSize })))));
    }
}
function mapStateToProps(state) {
    return {
        isTransportHovering: state.TransportOverlay.isTransportHovering,
        isTransportOverlayOpen: state.TransportOverlay.isTransportOverlayOpen,
        lastHoverTimestamp: state.TransportOverlay.lastHoverTimestamp,
        media: state.Media,
        showControls: state.VideoNPVState.showControls,
        windowWidth: state.BrowserState.windowWidth,
    };
}
function mapDispatchToProps(dispatch) {
    return {
        dispatch,
    };
}
export default withStyles(Styles)(connect(mapStateToProps, mapDispatchToProps)(VideoContainerTopSection));
